import axios from 'axios';

const basePath = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: basePath,
});

export default api;
